import styled from "@emotion/styled";

import { PropsToChildren } from "./PropsToChildren";

export const PropsToChildrenWrapper = styled.div().withComponent(PropsToChildren);

export const AnimationWrapper = styled.div<{
    inTransition: boolean;
    collapsed: boolean;
    tempHeight: undefined | number;
}>(
    _ => ({
        transition: "height 0.2s ease",
        position: "relative",
    }),
    props => ({
        height: props.collapsed ? 0 : props.inTransition ? props.tempHeight : undefined,
    }),
    props =>
        (props.inTransition || props.collapsed) && {
            overflow: "hidden",

            [`${PropsToChildrenWrapper}`]: {
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
            },
        }
);
